module.exports = __webpack_public_path__ + "static/images/search-glass-outline.c23957baa9fa5f198f9f2b9c48de8f92.svg";